"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Title = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _Title = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Title.css") : void 0);
var _excluded = ["className", "children", "headingLevel", "headingStyle"];
var CSS_BLOCK = 'sapcnqr-title';

/**
 * The **Title** component provides a way to make headings accessible by
 * separating the heading tag from the heading style, allowing for more
 * flexibility in design while still adhering to accessibility best practices.
 *
 * As a general accessibility rule, it's not ideal to truncate text.  There are
 * certain circumstances, however, that do necessitate a truncation pattern.
 * In cases like this, consult the CSS Helper Mixins patterns:
 * - [Text Overflow](./?path=/docs/patterns-css-helper-mixins--docs#text-overflow)
 * - [Text Overflow
 * Clamp](./?path=/docs/patterns-css-helper-mixins--docs#text-overflow-clamp)
 */

var Title = exports.Title = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _context;
  var className = props.className,
    children = props.children,
    headingLevel = props.headingLevel,
    headingStyle = props.headingStyle,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_Title.default);
  var headingClassTag = headingStyle ? "h".concat(headingStyle) : "h".concat(headingLevel);
  var classes = classnames(CSS_BLOCK, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, headingClassTag), className);
  var HeadingTag = "h".concat(headingLevel);
  return /*#__PURE__*/_react.default.createElement(HeadingTag, (0, _extends2.default)({}, otherProps, {
    className: classes,
    ref: ref
  }), children);
});
Title.displayName = 'Title';
Title.propTypes = {
  /** Semantic level of the heading to use.  Will use the `<h#>` element in the markup. */
  headingLevel: _CustomPropTypes.default.range(1, 6).isRequired,
  /** Contents of the heading element. */
  children: _propTypes.default.node,
  /** Additional classname(s) to add to the `<h#>` element. */
  className: _propTypes.default.string,
  /** Heading level style to use when rendering the component.  This does not change
   * the semantic heading level of the element. */
  headingStyle: _CustomPropTypes.default.range(1, 6)
};
var _default = exports.default = Title;